<template>
  <div :class="$style.container">
    <div :class="$style.mainContent">
      <div :class="$style.header">
        <div :class="$style.headerContent">
          <div :class="$style.breadcrumbs">
            <div :class="$style.text">Private Pilot 2025</div>
            <div>|</div>
            <div :class="$style.text">Pilot Qualifications</div>
            <div>|</div>
            <b :class="$style.pageTitle"
              >{{ isEdit ? "Edit" : "Create" }} Assignment</b
            >
          </div>
        </div>
        <div :class="$style.backButton" @click="navigateBack">
          <img
            :class="$style.backIcon"
            alt=""
            src="/static/img/LeftChevron.svg"
          />
        </div>
      </div>
      <div :class="$style.assignmentSection">
        <div :class="$style.assignmentHeader">
          <b :class="$style.text"
            >{{ isEdit ? "Edit" : "Create" }} Assignment</b
          >
          <div :class="$style.toggleGraded">
            <div :class="$style.mainIcons" v-if="isEdit">
              <img
                style="margin-right: 15px"
                alt=""
                src="/static/img/Trash.svg"
                @click="deleteAssignment"
              />
              <img
                alt=""
                src="/static/img/duplicate.svg"
                @click="duplicateAssignment"
              />
            </div>
            <div :class="$style.fieldInput1" v-if="form.isGraded">
              <input
                v-model="form.points"
                :class="$style.text"
                type="number"
                placeholder="Value..."
                disabled
              />
            </div>
            <div :class="$style.text">Graded</div>
            <el-switch
              style="display: block"
              v-model="form.isGraded"
              active-color="#00a551"
              inactive-color="#d54b4e"
            >
            </el-switch>
          </div>
        </div>
        <div :class="$style.fieldGroup">
          <div :class="$style.text">Assignment Title</div>
          <div :class="$style.fieldInput1">
            <input
              v-model="form.name"
              :class="$style.text"
              type="text"
              placeholder="Title..."
              :disabled="loading"
            />
          </div>
        </div>
        <div :class="$style.fieldGroup">
          <div :class="$style.text">Assignment Type</div>
          <HiloSelect
            :options="lessonTypes"
            v-model="selectedType"
            style="width: 100%; height: 47px"
            :searchable="true"
            :disabled="loading"
          />
        </div>
        <div :class="$style.fieldGroup">
          <div :class="$style.text">Assignment Objective</div>
          <div :class="$style.fieldInput1">
            <input
              v-model="form.description"
              :class="$style.text"
              type="text"
              placeholder="Write objective..."
              :disabled="loading"
            />
          </div>
        </div>
      </div>
      <div
        :class="$style.assignmentSection"
        v-for="(question, index) in form.questions"
        :key="index"
      >
        <div :class="$style.question">
          <b :class="$style.questionLabel">Question {{ index + 1 }}</b>
          <div :class="$style.pointValue" v-if="form.isGraded">
            <div :class="$style.text">Point Value</div>
            <input
              v-model="form.questions[index].points"
              :class="$style.pointInput"
              type="number"
              placeholder="Value..."
              :onchange="calculateQuestionPoint(index)"
              :disabled="
                questionType(index) !== 1 || !questionType(index) || loading
              "
            />
          </div>
        </div>

        <div :class="$style.questionDetails">
          <div :class="$style.questionText">
            <div :class="$style.text">Question</div>
            <input
              v-model="form.questions[index].question"
              :class="$style.pointInput"
              type="text"
              placeholder="Type question..."
              :disabled="!questionType(index) || loading"
            />
          </div>
          <div :class="$style.questionType">
            <div :class="$style.text">Type</div>
            <HiloSelect
              :options="questionTypes"
              style="width: 100%; height: 47px"
              :searchable="true"
              :disabled="loading"
              placeholder="Choose one..."
              v-model="form.questions[index].questionType"
            />
          </div>
        </div>
        <textarea
          placeholder="Type answer..."
          v-if="questionType(index) === 1"
          rows="4"
          :class="$style.fieldInputAbsolute1"
          v-model="form.questions[index].answer"
          :disabled="loading"
        />
        <div :class="$style.questionDetails1" v-if="questionType(index) === 4">
          <div
            :class="$style.gridGroup"
            v-for="(pairing, matchingIndex) in form.questions[index].matching"
            :key="matchingIndex"
            :style="`grid-template-columns: ${
              (form.questions[index].matching || []).length > 0
                ? '10fr 10fr 5fr 1fr'
                : '2fr 2fr 1fr'
            }`"
          >
            <textarea
              rows="3"
              :class="$style.fieldInputAbsolute1"
              placeholder="Type title..."
              @input="updateLabel(index, matchingIndex, true)"
              :disabled="loading"
              v-model="form.questions[index].matching[matchingIndex].title"
            />
            <textarea
              rows="3"
              :class="$style.fieldInputAbsolute1"
              placeholder="Type description..."
              @input="updateLabel(index, matchingIndex, true)"
              :disabled="loading"
              v-model="
                form.questions[index].matching[matchingIndex].description
              "
            />
            <input
              type="number"
              :class="$style.fieldInputAbsolute1"
              placeholder="Point value..."
              v-model="form.questions[index].matching[matchingIndex].points"
              @input="updatePoints(index, true)"
              :disabled="loading"
              v-if="form.isGraded"
            />
            <img
              v-if="(form.questions[index].matching || []).length > 0"
              :class="$style.iconTrash"
              src="/static/img/Trash.svg"
              @click="removeItem(matchingIndex, index, 'matching')"
            />
          </div>
          <div :class="$style.addChoices" @click="addAnswer(index)">
            <div :class="$style.text">+ Add Pairing</div>
          </div>
        </div>
        <div
          :class="$style.fieldGroup"
          v-if="questionType(index)"
          style="width: 100%"
        >
          <div
            :class="$style.answersHeader"
            v-if="
              (questionType(index) === 2 || questionType(index) === 3) &&
              (form.questions[index].choices || []).length
            "
          >
            <div :class="$style.text">Answers to choose from</div>
            <div :class="$style.text" v-if="form.isGraded">Point Value</div>
          </div>
          <div v-if="questionType(index) === 2" style="width: 100%">
            <div
              :class="$style.flexGroupCustom"
              v-for="(choice, choiceIndex) in form.questions[index].choices"
              :key="choiceIndex"
            >
              <div
                :class="$style.fieldInputAbsolute"
                :style="!form.isGraded ? 'width: 100%;' : ''"
              >
                <input
                  v-model="form.questions[index].choices[choiceIndex].label"
                  :class="$style.text"
                  type="text"
                  :disabled="loading"
                  placeholder="Type choice..."
                  @input="updateLabel(index, choiceIndex)"
                />
                <img
                  v-if="(form.questions[index].choices || []).length > 0"
                  :class="$style.iconTrash"
                  src="/static/img/Trash.svg"
                  @click="removeItem(choiceIndex, index, 'choices')"
                />
              </div>
              <div :class="$style.fieldInput" v-if="form.isGraded">
                <input
                  v-model="form.questions[index].choices[choiceIndex].points"
                  :disabled="loading"
                  :class="$style.text"
                  type="number"
                  placeholder="Points..."
                  @input="updatePoints(index)"
                  min="0"
                  @change="
                    (evt) => multipleChoicePoints(evt, index, choiceIndex)
                  "
                />
              </div>
            </div>
            <div :class="$style.addChoices" @click="addAnswer(index)">
              <div :class="$style.text">+ Add Answer</div>
            </div>
          </div>

          <div v-if="questionType(index) === 3" style="width: 100%">
            <div
              :class="$style.flexGroupCustom"
              v-for="(choice, choiceIndex) in form.questions[index].choices"
              :key="choiceIndex"
            >
              <div
                :class="$style.fieldInputAbsolute"
                :style="!form.isGraded ? 'width: 100%;' : ''"
              >
                <!-- <input type="checkbox" @change="(e) => onCheckChange(e, index, choiceIndex)" :checked="form.questions[index].choices[choiceIndex].isChecked" style="width: 15px; position: absolute; left: 15px; z-index: 999"> -->
                <input
                  v-model="form.questions[index].choices[choiceIndex].label"
                  :class="$style.text"
                  type="text"
                  placeholder="Type choice..."
                  @input="updateLabel(index, choiceIndex)"
                  :disabled="loading"
                />
                <img
                  v-if="(form.questions[index].choices || []).length > 0"
                  :class="$style.iconTrash"
                  src="/static/img/Trash.svg"
                  @click="removeItem(choiceIndex, index, 'choices')"
                />
              </div>
              <div :class="$style.fieldInput" v-if="form.isGraded">
                <input
                  v-model="form.questions[index].choices[choiceIndex].points"
                  :class="$style.text"
                  type="number"
                  placeholder="Points..."
                  @input="updatePoints(index)"
                  :disabled="loading"
                />
              </div>
            </div>
            <div :class="$style.addChoices" @click="addAnswer(index)">
              <div :class="$style.text">+ Add choice</div>
            </div>
          </div>
        </div>
      </div>
      <div :class="$style.footerActions">
        <div :class="$style.addQuestionButton" @click="addQuestion">
          <div :class="$style.text">Add Question</div>
        </div>
        <div :class="$style.saveAssignmentWrapper" @click="onSave">
          <b :class="$style.text">Save Assignment</b>
        </div>
      </div>
    </div>

    <el-dialog center title="Success" :visible.sync="modals.success">
      <div class="text-center">
        <span>Success: {{ success_txt }}</span>
        <br />
        <span slot="footer" class="dialog-footer">
          <button class="btn btn-success" @click="closeModal('success')">
            OK</button
          >&nbsp;
        </span>
      </div>
    </el-dialog>
    <ToastNotifier ref="toast" />
  </div>
</template>
<script>
import { Switch } from "element-ui";
import HiloSelect from "@/components/HiloComponents/HiloSelect.vue";
import { Input, Button, Dialog } from "element-ui";
import AssignmentsAPIService from "../../../../servicehandlers/AssignmentsAPIService.js";
import QuestionAPIService from "../../../../servicehandlers/QuestionsAPIService.js";
import ToastNotifier from "@/components/ToastNotifier.vue";
import { useFormStore } from "../../../../stores/formStore.js";
import { mapState, mapActions } from "pinia";
const assignmentService = new AssignmentsAPIService();
const questionService = new QuestionAPIService();
export default {
  components: {
    [Switch.name]: Switch,
    [Input.name]: Input,
    [Button.name]: Button,
    [Dialog.name]: Dialog,
    HiloSelect,
    ToastNotifier,
  },
  data() {
    return {
      form: {
        isGraded: true,
        questions: [
          {
            value: "",
            question: "",
            questionType: "",
          },
        ],
      },
      questionTypes: [],
      lessonTypes: [],
      modalStyle: {
        top: "0px",
        left: "0px",
      },
      modals: {
        error: false,
        success: false,
        delete: false,
        add: false,
      },
      success_txt: "",
      selectedType: null,
      loading: false,
    };
  },
  watch: {
    form: {
      deep: true,
      handler(newVal) {
        let points = 0;
        this.form.questions.forEach((question) => {
          if (question.questionType === 2 && question.choices?.length) {
            const maxPoints = question.choices.reduce((max, choice) => {
              const points = parseInt(choice.points) || 0;
              return points > max ? points : max;
            }, 0);

            if (question.points !== maxPoints) question.points = maxPoints;
          } else if (question.questionType === 3 && question.choices?.length) {
            const totalPoints = question.choices.reduce((sum, choice) => {
              return sum + (parseInt(choice.points) || 0);
            }, 0);

            if (question.points !== totalPoints) question.points = totalPoints;
          } else if (question.questionType === 4 && question.matching?.length) {
            const totalPoints = question.matching.reduce((sum, choice) => {
              return sum + (parseInt(choice.points) || 0);
            }, 0);

            if (question.points !== totalPoints) question.points = totalPoints;
          }

          points += parseInt(question.points) || 0;
        });

        this.form.points = points;
        this.$forceUpdate();
      },
    },
  },
  computed: {
    ...mapState(useFormStore, ["assignmentPayload"]),
    isEdit() {
      return (
        this.$route.query.type && this.$route.query.assignmentId !== undefined
      );
    },
  },
  async mounted() {
    this.getAssignmentTypes();
    try {
      this.questionTypes = (await questionService.getAllQuestionTypes()).filter(
        (type) => type.id !== 1,
      ); // todo: hide for v1

      if (this.isEdit) {
        this.loading = true;
        const assignment = await assignmentService.getAssignmentById(
          this.$route.query.assignmentId,
          this.$router,
        );
        this.form = {
          ...assignment,
          isGraded: assignment.graded,
          questions: assignment.questions.map((question) => {
            const defaultPayload = {
              question: question.question,
              questionType: question.questionTypeId,
            };
            return question.questionTypeId === 1
              ? {
                  ...defaultPayload,
                  answer: question.questionChoices[0].description,
                  points: question.questionChoices[0].pointValue,
                }
              : question.questionTypeId === 2 || question.questionTypeId === 3
                ? {
                    ...defaultPayload,
                    choices: question.questionChoices.map((choice) => {
                      return {
                        label: choice.description,
                        points: choice.pointValue,
                      };
                    }),
                  }
                : {
                    ...defaultPayload,
                    matching: question.questionChoices.map((choice) => {
                      return {
                        title: choice.description,
                        description: choice.matchingString,
                        points: choice.pointValue,
                      };
                    }),
                  };
          }),
        };
        this.selectedType = assignment.assignmentTypeId;
      }
    } catch (error) {
      this.$refs.toast.showError("Error fetching assignment types");
    } finally {
      this.loading = false;
    }
  },
  methods: {
    ...mapActions(useFormStore, [
      "setAssignmentPayload",
      "clearAssignmentPayload",
    ]),
    deleteAssignment() {
      assignmentService
        .deleteAssignment(this.$route.query.assignmentId, this.$router)
        .then(() => {
          this.$refs.toast.showSuccess("Assignment has been deleted.");
          this.navigateBack();
        });
    },
    duplicateAssignment() {
      assignmentService
        .duplicateAssignment(this.$route.query.assignmentId, this.$router)
        .then(() => {
          this.$refs.toast.showSuccess("Assignment has been duplicated.");
          this.navigateBack();
        });
    },
    getAssignmentTypes() {
      assignmentService.getAllAssignmentTypes(this.$router).then((response) => {
        this.lessonTypes = response;
      });
    },
    calculateQuestionPoint(qIndex) {
      const points = this.form.questions[qIndex].points;

      if (points < 0) {
        this.form.questions[qIndex].points = 0;
        this.$forceUpdate();
      }
    },
    onCheckChange(e, questionIndex, choiceIndex) {
      this.form.questions[questionIndex].choices[choiceIndex].isChecked =
        e.target.checked;
      this.$forceUpdate();
    },
    multipleChoicePoints(evt, qIndex, cIndex) {
      if (evt.target.value < 0) {
        this.form.questions[qIndex].choices[cIndex].points = 0;

        const qPoints = this.calculatePoints(
          this.form.questions[qIndex].choices,
          this.questionType(qIndex) === 2,
        );
        this.form.questions[qIndex].points = qPoints < 0 ? 0 : qPoints;
        this.$forceUpdate();
      }
    },
    updatePoints(questionIndex, isMatching = false) {
      const points = this.calculatePoints(
        this.form.questions[questionIndex][isMatching ? "matching" : "choices"],
        this.questionType(questionIndex) === 2,
      );
      this.form.questions[questionIndex].points = points || 0;

      this.form.points = this.calculatePoints(this.form.questions);
      this.$forceUpdate();
    },
    updateLabel(questionIndex, choiceIndex, isMatching = false) {
      const choice =
        this.form.questions[questionIndex][isMatching ? "matching" : "choices"][
          choiceIndex
        ];
      choice.label = choice.label;
      if (isMatching) choice.description = choice.description;
      this.$forceUpdate();
    },
    calculatePoints(arr, isMultipleChoice = false) {
      if (arr && arr.length) {
        const mappedPoints = arr.map((choice) => {
          return parseInt(choice.points || "0");
        });

        if (isMultipleChoice) {
          const largest = Math.max(...mappedPoints);
          return largest;
        }

        return arr.reduce((sum, choice) => {
          return sum + parseInt(choice.points < 0 ? 0 : choice.points);
        }, 0);
      }
      return 0;
    },
    questionType(index) {
      return this.form.questions[index].questionType;
    },
    navigateBack() {
      this.$router.go(-1);
    },
    async onSave() {
      try {
        const questions = this.form.questions.map((question) => {
          const qType = question.questionType;

          return {
            question: question.question,
            questionTypeId: question.questionType,
            questionChoices:
              qType === 2 || qType === 3
                ? (question.choices || []).map((choice) => {
                    return {
                      description: choice.label,
                      pointValue: parseFloat(choice.points),
                    };
                  })
                : qType === 4
                  ? (question.matching || []).map((choice) => {
                      return {
                        description: choice.title,
                        pointValue: parseFloat(choice.points),
                        matchingString: choice.description,
                      };
                    })
                  : [
                      {
                        description: question.answer,
                        pointValue: parseFloat(question.points),
                      },
                    ],
          };
        });

        let payload = {
          name: this.form.name,
          assignmentTypeId: this.selectedType,
          description: this.form.description,
          questions,
        };

        const requiredFields = Object.keys(payload).filter((x) => !payload[x]);
        const validations =
          this.$global.createMultipleValidations(requiredFields);

        payload.graded = this.form.isGraded;

        questions.forEach((question, index) => {
          const choiceTypes =
            question.questionTypeId === 2 ||
            question.questionTypeId === 3 ||
            question.questionTypeId === 4;

          // should require a question
          if (!question.question) {
            validations.push(`Question ${index + 1} is missing a question. `);
          }

          // should require a question type
          if (!question.questionTypeId) {
            validations.push(
              `Question ${index + 1} is missing a question type. `,
            );
          }

          // should require atleast two choices
          if (choiceTypes && question.questionChoices.length < 2) {
            validations.push(
              `Question ${index + 1} should atleast have two ${question.questionTypeId === 4 ? "pairings" : "choices. "}`,
            );
          }

          // check if choices have empty fields including title and description
          if (choiceTypes && question.questionChoices.length) {
            const hasUnfilledChoices = question.questionChoices.some(
              (choice) => {
                return question.questionTypeId === 4
                  ? !choice.description || !choice.matchingString
                  : !choice.description;
              },
            );
            if (hasUnfilledChoices) {
              validations.push(`Question ${index + 1} fields are required. `);
            }
          }

          // check if choices have points
          if (choiceTypes && question.questionChoices.length) {
            const hasPoints = question.questionChoices.some(
              (choice) => choice.pointValue || choice.pointValue > 1,
            );
            if (!hasPoints && payload.graded)
              validations.push(
                `Question ${index + 1} has an empty point value. `,
              );
          }

          // check if short answer has empty fields
          if (
            question.questionTypeId === 1 &&
            !question.questionChoices[0].description
          ) {
            validations.push(`Question ${index + 1} is missing an answer. `);
          }

          // check if short answer has points
          if (
            question.questionTypeId === 1 &&
            (question.questionChoices[0].pointValue || 0) < 1 &&
            payload.graded
          ) {
            validations.push(
              `Question ${index + 1} is missing a point value. `,
            );
          }
        });

        if (validations.length) {
          this.$refs.toast.showError(validations);
          return;
        }

        if (!this.isEdit && this.$route.query.fromCreateLesson) {
          setTimeout(() => {
            this.setAssignmentPayload([...this.assignmentPayload, payload]);
            this.$router.push({
              path: "/hilo/curriculumTemplates/courseDetails/createLesson",
              query: {
                curriculumStageId: this.$route.query.curriculumStageId,
                curriculumId: this.$route.query.curriculumId,
              },
            });
          }, 1000);
        } else if (this.$route.query.createAssignment) {
          payload.lessonId = this.$route.query.lessonId
            ? this.$route.query.lessonId
            : this.form.lessonId;
          await assignmentService.createAssignment(payload, this.$router);

          this.$refs.toast.showSuccess(`Assignment created successfully`);
          setTimeout(() => {
            this.navigateBack();
          }, 1000);
        } else if (this.$route.query.saveAssignment) {
          payload.lessonId = this.$route.query.lessonId
            ? this.$route.query.lessonId
            : this.form.lessonId;
          await assignmentService.updateAssignment(
            this.$route.query.assignmentId,
            payload,
            this.$router,
          );

          this.$refs.toast.showSuccess(`Assignment created successfully`);
          setTimeout(() => {
            this.navigateBack();
          }, 1000);
        } else if (this.$route.query.type && this.$route.query.assignmentId) {
          await assignmentService.updateAssignment(
            this.$route.query.assignmentId,
            payload,
            this.$router,
          );

          setTimeout(() => {
            this.navigateBack();
          }, 1000);

          this.$refs.toast.showSuccess(`Assignment updated successfully`);
        }
      } catch (error) {
        this.$refs.toast.showError(
          `Error ${this.isEdit ? "updating" : "creating"} assignment.`,
        );
      }
    },
    openModal(name) {
      this.modals[name] = true;
    },
    closeModal(name) {
      this.modals[name] = false;
    },
    handleSuccess(text) {
      this.success_txt = text;
      this.openModal("success");
      this.spinning = false;
      setTimeout(() => {
        this.modals["success"] = false;
        this.navigateBack();
      }, 1500);
    },
    handleError(error) {
      this.error_txt = error;
      this.openModal("error");
      this.spinning = false;
      setTimeout(() => {
        this.modals["error"] = false;
      }, 1500);
    },
    addQuestion() {
      this.form.questions.push({
        value: "",
        question: "",
        questionType: "",
      });
    },
    addAnswer(index) {
      const obj = { 2: "choices", 3: "choices", 4: "matching" };
      const key = obj[this.form.questions[index].questionType];

      if (key) {
        this.form.questions[index][key] = [
          ...(Array.isArray(this.form.questions[index][key])
            ? this.form.questions[index][key]
            : []),
          key === "choices"
            ? { label: "", points: 0 }
            : { title: "", description: "" },
        ];
        this.$forceUpdate();
      }
    },
    removeItem(propIndex, questionIndex, key) {
      this.form.questions[questionIndex][key].splice(propIndex, 1);

      const points = this.calculatePoints(
        this.form.questions[questionIndex][key],
      );
      this.form.questions[questionIndex].points = points;
      this.$forceUpdate();
    },
  },
};
</script>
<style module scoped>
img {
  cursor: pointer;
}
.mainIcons {
  width: 63px;
  height: 24px;
  overflow: hidden;
  flex-shrink: 0;
}
.iconTrash {
  width: 24px;
  position: relative;
  height: 24px;
  overflow: hidden;
  flex-shrink: 0;
  cursor: pointer;
}

.text {
  position: relative;
}

.pageTitle {
  position: relative;
  color: #404040;
}

.breadcrumbs {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.headerContent {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0 20px;
  z-index: 0;
}

.backIcon {
  width: 16px;
  position: relative;
  height: 16px;
  overflow: hidden;
  flex-shrink: 0;
  object-fit: contain;
  cursor: pointer;
}

.backButton {
  margin: 0 !important;
  position: absolute;
  top: 2px;
  left: 0;
  background-color: #f6f6f6;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 5px 20px;
  z-index: 1;
}

.header {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0 50px;
  position: relative;
  gap: 20px;
  font-size: 25px;
  color: rgba(64, 64, 64, 0.5);
}

.toggleThumb {
  position: absolute;
  top: calc(50% - 13px);
  right: 2px;
  border-radius: 100px;
  background-color: #fff;
  width: 26px;
  height: 26px;
}

.toggleSwitch {
  width: 50px;
  position: relative;
  border-radius: 100px;
  background-color: #00a551;
  height: 30px;
  overflow: hidden;
  flex-shrink: 0;
}

.toggleGraded {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 20px;
  font-size: 15px;
}

.assignmentHeader {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: 40px;
}

.fieldInput,
.fieldInput1,
.fieldInputAbsolute {
  align-self: stretch;
  border-radius: 10px;
  box-sizing: border-box;
  height: 47px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  color: rgba(64, 64, 64, 0.75);
  width: 100%;
  padding: 0;
}
.fieldInput {
  width: 20%;
}

.gridGroup {
  width: 100%;
  display: grid;
  align-items: center;
  gap: 10px;
}

.gridGroup .fieldInputAbsolute1,
.fieldInputAbsolute1,
.questionDetails input,
.assignmentSection input,
.addChoices {
  border-radius: 10px;
  border: 1px solid rgba(64, 64, 64, 0.25);
  color: rgba(64, 64, 64, 0.75);
  width: 100%;
  resize: none;
  padding: 10px 20px;
  background: #fff;
  outline: none;
}
/*textarea {
  line-height: 1.5em;
  min-height: calc(1.5em * 2);  !* Minimum 2 rows *!
  max-height: calc(1.5em * 6);  !* Maximum 6 rows *!
  resize: vertical;            !* Allows vertical resizing within limits *!
}*/

.gridGroup input:disabled,
.gridGroup textarea:disabled,
.fieldInputAbsolute1:disabled,
.questionDetails input:disabled,
.assignmentSection input:disabled {
  background: #f5f5f5;
}

.fieldInput1 {
  cursor: pointer;
  gap: 5px;
}

.fieldInputAbsolute {
  position: relative;
  width: 80%;
}

.fieldInputAbsolute img {
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 999;
}

.fieldGroup {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
}

.flexGroup,
.flexGroupCustom {
  display: flex;
  gap: 10px;
  width: 100%;
}

.flexGroupCustom {
  margin-bottom: 10px;
  grid-template-columns: 4fr 1fr;
}

.fieldDropdown {
  align-self: stretch;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.05);
  border: 1px solid #d5d5d5;
  box-sizing: border-box;
  height: 47px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  color: #707070;
}

.assignmentSection {
  width: 900px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background-color: #fff;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 50px 75px;
  box-sizing: border-box;
  gap: 25px;
}

.questionLabel {
  flex: 1;
  position: relative;
}

.pointInput {
  border-radius: 10px;
  border: 1px solid rgba(64, 64, 64, 0.25);
  box-sizing: border-box;
  height: 47px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0 20px;
  color: rgba(64, 64, 64, 0.75);
}

.pointValue {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 15px;
}

.question {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 22px;
}

.questionText {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
}

.questionType {
  width: 200px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
}

.questionDetails {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 30px;
}

.questionDetails1 {
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
}

.questionDetails1 .questionType {
  width: 100%;
}

.answersHeader {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.addQuestionButton {
  flex: 1;
  border-radius: 10px;
  background-color: rgba(64, 64, 64, 0.15);
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  cursor: pointer;
  transition: 0.2s ease-in-out;
}

.saveAssignmentWrapper {
  flex: 1;
  border-radius: 10px;
  background-color: #3c78ff;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  cursor: pointer;
  color: #fff;
  transition: 0.2s ease-in-out;
}

.addQuestionButton:hover,
.saveAssignmentWrapper:hover {
  opacity: 0.8;
}

.footerActions {
  width: 900px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  font-size: 18px;
}

.mainContent {
  align-self: stretch;
  flex: 1;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 35px 0 0;
  gap: 25px;
  z-index: 0;
  text-align: left;
  font-size: 15px;
  color: #404040;
  margin-bottom: 50px;
}

.container {
  height: 100%;
  flex: 1;
  width: 100%;
  position: relative;
  background-color: #f6f6f6;
  overflow-y: auto;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  font-size: 18px;
  color: rgba(64, 64, 64, 0.5);
  font-family: Helvetica, Arial, sans-serif;
}
</style>
